export const theme = {
  normal: "0",
  round: "100%",
  rounded: "24px",
  transparent: "transparent",
  black: "#000",
  dark: "#333",
  bright: "#ccc",
  white: "#fff",
  blue: "#004A96",
  blueDark: "#004A96",
  blueBright: "#21A0D2",
  greenDark: "#00793A",
  greenBright: "#65AC1E",
  orange: "#F39500",
  red: "#C50022",
  purple: "#A000C5",
  yellow: "#E0DA00",
  blueDarkHalf: "#7FA4CA",
  blueBrightHalf: "#90CFE8",
  greenDarkHalf: "#7FBC9C",
  greenBrightHalf: "#B2D58E",
  orangeHalf: "#F9CA7F",
  redHalf: "#E27F90",
};
